export default [{
  path: '/portal-documento',
  component: {
    name: 'portaldocumentoBase',
    template: '<router-view />',
    meta: {
      resource: 'portal_documentos',
      action: 'read',
      requiredAuth: true,
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    query: {
      busca: '',
      filtroRapido: '',
    },
    name: 'portal-documento-view',
    component: () => import('@/app/portal-documento/PortalDocumentosView.vue'),
    meta: {
      resource: 'portal_documentos',
      action: 'read',
      navActiveLink: 'portal-documento-view',
      pageTitle: 'Downloads',
      breadcrumb: [
        {
          text: 'Downloads',
          to: { name: 'portal-documento-view' },
          active: true,
        },
      ],
    },
  }],
},
]
